import { setSafe } from "../../../util/storeHelper";
import * as actions from "../actions/settings";
export const loadOrderSettingsReducer = {
    reducers: {
        [actions.setGameLoadOrderRendererOptions]: (state, payload) => {
            const { gameId, itemRendererOptions } = payload;
            return setSafe(state, ["rendererOptions", gameId], itemRendererOptions);
        },
    },
    defaults: {},
};
